module.exports = __webpack_public_path__ + "media/images/icons/sw-eng-a54cdb19a7ee6bc80bcb56340c5fcd3a.svg";